// src/features/products/supplierApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const UnitsApi = createApi({
  reducerPath: 'UnitsApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.Units.get }),
  tagTypes: ['UnitsApi'],
  endpoints: (builder) => ({
    getUnits: builder.query({
      query: () => "getUnites",
      keepUnusedDataFor: 35,
      providesTags: ['UnitsApi'],
      invalidatesTags: ['UnitsApi'],
    }),
    createUnits: builder.mutation({
      query: (supplier) => {
        const formData = new FormData();
        Object.entries(supplier).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.Units.post,
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response, meta, arg) => {
       
        return response
      },
      invalidatesTags: ['UnitsApi'], 
    }),
    updateUnits: builder.mutation({
      query: (UnitsData) => {
        const formData = new FormData();
        Object.entries(UnitsData).forEach(([key, value]) => {
          formData.append(key, value);
        });
        return {
          url: Urls.Units.update + UnitsData.Id,
          method: 'PUT',
          body: formData,
          
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['UnitsApi'],
    }),
    deleteUnits: builder.mutation({
      query: (id) => ({
        url: Urls.Units.delete + id,
        method: 'DELETE',
      }),
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['UnitsApi'],
    }),
  }),
  keepUnusedDataFor: 1
});

export const {
  useGetUnitsQuery,
  useCreateUnitsMutation,
  useUpdateUnitsMutation,
  useDeleteUnitsMutation,
} = UnitsApi;

